/**
 * TrustScore — Small trust bar shown in agent mode header
 * Builds with each user approval
 */
import React from 'react';

const TrustScore = ({ score = 0 }) => {
  const percentage = Math.min(100, Math.max(0, score));
  const color = percentage >= 60 ? 'bg-green-400' : percentage >= 30 ? 'bg-amber-400' : 'bg-red-400';

  return (
    <div className="flex items-center gap-1.5" title={`Trust Score: ${percentage}%`}>
      <div className="w-16 h-1.5 bg-white/20 rounded-full overflow-hidden">
        <div
          className={`h-full ${color} rounded-full transition-all duration-500`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <span className="text-xs text-white/70">{percentage}%</span>
    </div>
  );
};

export default TrustScore;
